import template from './template.html';
import './styles.css';

controller.$inject = ['StoresService', '$state'];

export function controller(StoresService, $state) {
    const vm = this;
    vm.disabled = true;
    vm.loading = true;

    StoresService.getStores().then(stores => {
        vm.stores = [...stores];
        vm.disabled = false;
        vm.loading = false;
        return StoresService.getStore().then(store => {
            vm.selected = vm.stores.filter(element => element.storeId === store.storeId)[0];
            if (vm.store !== undefined) {
                vm.store = vm.selected;
            }
        });
    });

    vm.select = select;
    vm.storeLabel = storeLabel;

    function storeLabel(store) {
        const id = String('0000' + store.storeId).slice(-4);
        return `${store.storeName} ( A${id} )`;
    }

    function select() {
        StoresService.setStore(vm.selected);
        vm.store = vm.selected;
        $state.go('schedules', {
            storeId: vm.selected.storeId
        });
    }
}

export default () => ({
    template: template,
    controller: controller,
    restrict: 'EA',
    controllerAs: 'vm',
    bindToController: {
        store: '=storeselector',
        suppressLoadingIndicator: '='
    },
    scope: {}
});



// WEBPACK FOOTER //
// ./src/js/components/common/storeselector/index.js